module.exports = __webpack_public_path__ + "static/img/QLD-shield-logo.51dd678.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/QLD-shield-logo.svg
// module id = RvdW
// module chunks = 0